let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6MNAi"), load("425pi"), load("kIryJ")]).then(() => parcelRequire('j2TUq'));